/**
 * Moon Texture Cache
 * Manages Data3DTexture arrays to prevent re-creation
 */

const textureArrayCache = new Map()

/**
 * Get cached texture array
 * @param {string} quality - Quality level
 * @returns {Data3DTexture|null}
 */
export function getCachedTextureArray(quality) {
  const key = `moon_diffuse_${quality}`
  return textureArrayCache.get(key) || null
}

/**
 * Set cached texture array
 * @param {string} quality - Quality level
 * @param {Data3DTexture} textureArray
 */
export function setCachedTextureArray(quality, textureArray) {
  const key = `moon_diffuse_${quality}`
  textureArrayCache.set(key, textureArray)
}

/**
 * Check if texture array exists in cache
 * @param {string} quality - Quality level
 * @returns {boolean}
 */
export function hasTextureArray(quality) {
  const key = `moon_diffuse_${quality}`
  return textureArrayCache.has(key)
}

/**
 * Clear all cached textures
 */
export function clearTextureCache() {
  textureArrayCache.forEach((texture) => {
    if (texture && texture.dispose) {
      texture.dispose()
    }
  })
  textureArrayCache.clear()
}
